import { render, staticRenderFns } from "./BusinessClientCommunities.vue?vue&type=template&id=53661ad8&scoped=true&"
import script from "./BusinessClientCommunities.vue?vue&type=script&lang=ts&"
export * from "./BusinessClientCommunities.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessClientCommunities.vue?vue&type=style&index=0&id=53661ad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53661ad8",
  null
  
)

export default component.exports